/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Report_TranscriptInputs */



/**
* | output |
* | --- |
* | "Transcript" |
*
* @param {Practice_Report_TranscriptInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_report_transcript = /** @type {((inputs?: Practice_Report_TranscriptInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Report_TranscriptInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Transcript")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Transcription")
	return /** @type {LocalizedString} */ ("Transcript")
});